import { addVehicle, deleteVehicleById, getAllBookingVehicleById, getAllVehicle, getAllVehicleGroup, getIncomeByVehicleId, getVehicleById, updateVehicle,addVehicleGroup, getAllDashboardCount } from "../../../helpers/backend_helper";
import { getVehicleByIdError, getVehicleByIdRequest, getVehicleByIdSuccess, vehicleDeleteSuccess, vehicleError, vehicleRequest, vehicleSuccess } from "./reducer";

export const fetchVehicle = (page:number,count:number,keyword:string) => async (dispatch: any) => {
    dispatch(vehicleRequest());
    try {
      const response: any = await getAllVehicle(page,count,keyword);
      if (response && response.isSuccess) {
        dispatch(vehicleSuccess(response.data));
        return response
      } else {
        dispatch(vehicleError("Failed to fetch Vehicle"));
        return null

      }
    } catch (error: any) {
      dispatch(vehicleError(error.message));
      return null
    }
  };
  
  
export const fetchVehicleGroup = (page:number,count:number,keyword:string) => async (dispatch: any) => {
  dispatch(vehicleRequest());
  try {
    const response: any = await getAllVehicleGroup(page,count,keyword);
    if (response && response.isSuccess) {
      dispatch(vehicleSuccess(response.data));
      return response
    } else {
      dispatch(vehicleError("Failed to fetch Vehicle Group"));
      return response

    }
  } catch (error: any) {
    dispatch(vehicleError(error.message));
    return null
  }
};

  export const addNewVehicle = (userData: any) => async (dispatch: any) => {
    dispatch(vehicleRequest());
    try {
      const response: any = await addVehicle(userData);
      if (response && response.data) {
        dispatch(vehicleSuccess(response.data));
        return response
      } else {
        dispatch(vehicleError("Failed to add user"));
        return response

      }
    } catch (error: any) {
      dispatch(vehicleError(error.message));
      return null
    }
  };

  
  export const addNewVehicleGroups = (userData: any) => async (dispatch: any) => {
    dispatch(vehicleRequest());
    try {
      const response: any = await addVehicleGroup(userData);
      if (response && response.data) {
        dispatch(vehicleSuccess(response.data));
        return response
      } else {
        dispatch(vehicleError("Failed to add user"));
        return response
      }
    } catch (error: any) {
      dispatch(vehicleError(error.message));
      return null
    }
  };
  
  export const editVehicle = (updatedData: any) => async (dispatch: any) => {
    dispatch(vehicleRequest());
    try {
      const response: any = await updateVehicle(updatedData);
      if (response && response.data) {
        dispatch(vehicleSuccess(response.data));
      } else {
        dispatch(vehicleError("Failed to edit user"));
      }
    } catch (error: any) {
      dispatch(vehicleError(error.message));
    }
  };
 
  export const fetchVehicleById = (id: string) => async (dispatch: any) => {
    dispatch(getVehicleByIdRequest());
    try {
      const response: any = await getVehicleById(id);  
  
      if (response && response.isSuccess) {
        dispatch(getVehicleByIdSuccess(response.data)); 
        return response; 
      } else {
        dispatch(getVehicleByIdError("Failed to fetch vehicle by ID"));
        return null; 
      }
    } catch (error: any) {
      dispatch(getVehicleByIdError(error.message));  
      return null;
    }
  };
  
  export const removeVehicle = (id: string) => async (dispatch: any) => {
    dispatch(vehicleRequest());
    try {
      const response: any = await deleteVehicleById(id);
      debugger
      if (response && response.isSuccess) {
        dispatch(vehicleSuccess(id));
        return response
      } else {
        dispatch(vehicleError("Failed to delete user"));
        return response
      }
    } catch (error: any) {
      dispatch(vehicleError(error.message));
      return null
    }
  };


export const fetchBookingByVehicleId = (page:number,count:number,id:string,keyword?:string) => async (dispatch: any) => {
    dispatch(vehicleRequest());
    try {
      const response: any = await getAllBookingVehicleById(page,count,id,keyword);
      if (response && response.isSuccess) {
        dispatch(vehicleSuccess(response.data));
        return response
      } else {
        dispatch(vehicleError("Failed to fetch Vehicle"));
        return null

      }
    } catch (error: any) {
      dispatch(vehicleError(error.message));
      return null
    }
  };


  export const fetchIncomeByVehicleId = (page:number,count:number,id:string,keyword?:string) => async (dispatch: any) => {
    dispatch(vehicleRequest());
    try {
      const response: any = await getIncomeByVehicleId(page,count,id,keyword);
      if (response && response.isSuccess) {
        dispatch(vehicleSuccess(response.data));
        return response
      } else {
        dispatch(vehicleError("Failed to fetch Vehicle"));
        return null

      }
    } catch (error: any) {
      dispatch(vehicleError(error.message));
      return null
    }
  };  

export const deleteVehicleGroup = (id: string) => async (dispatch: any) => {
  dispatch(vehicleRequest());
  try {
    const response: any = await deleteVehicleGroup(id);
    if (response && response.isSuccess) {
      dispatch(vehicleSuccess(id));
      return response
    } else {
      dispatch(vehicleError("Failed to delete Vehicle Group"));
      return response
    }
  } catch (error: any) {
    dispatch(vehicleError(error.message));
    return null
  }
}  

export const getDashboardCount = () => async (dispatch: any) => {
  dispatch(vehicleRequest());
  try {
    const response: any = await getAllDashboardCount();
    if (response && response.isSuccess) {
      dispatch(vehicleSuccess(response.data));
      return response
    } else {
      dispatch(vehicleError("Failed to fetch Vehicle"));
      return null

    }
  } catch (error: any) {
    dispatch(vehicleError(error.message));
    return null
  }
}
  